import { useRoutes } from "react-router-dom"

import { DetailSegmentSelectListener, SegmentSelectListener } from "@l2r-front/l2r-common"
import { MapAdapterBoundingBox, MapAdapterRoad } from "@l2r-front/l2r-networks"
import { NavigateWithParams, useUrlParams } from "@l2r-front/l2r-utils"

import { VerticalSigningMobileContent } from "../../containers/VerticalSigningMobileContent"
import { VerticalSignPoleDetailsSidebar } from "../../containers/VerticalSignPoleDetailsSidebar"
import { VerticalSignSelectListener } from "../../containers/VerticalSignSelectListener"

import { VerticalSignPoleValidator } from "../VerticalSignPoleValidator"

export const VerticalSigningMobileRoutes = () => {
    const { getParams } = useUrlParams()
    const searchParams = getParams()

    const roadwayRoutes = useRoutes([
        {
            path: "/*",
            element: <>
                <MapAdapterBoundingBox />
                <VerticalSigningMobileContent />
                <SegmentSelectListener />
            </>,
        },
        {
            path: "/code/:code",
            element: <>
                <MapAdapterBoundingBox />
                <VerticalSigningMobileContent />
                <SegmentSelectListener />
            </>,
        },
        {
            path: "/:road",
            element: <>
                <DetailSegmentSelectListener />
                <MapAdapterRoad />
                <VerticalSigningMobileContent />
            </>,
        },
        {
            path: "/:road/:signId",
            element: <VerticalSignPoleValidator>
                <VerticalSignSelectListener />
                <VerticalSignPoleDetailsSidebar />
            </VerticalSignPoleValidator>,
        },
        {
            path: "/:road/code/:code",
            element: <>
                <DetailSegmentSelectListener />
                <MapAdapterRoad />
                <VerticalSigningMobileContent />,
            </>,
        },
        {
            path: "/:road/code/:code/:signId",
            element: <VerticalSignPoleValidator>
                <VerticalSignSelectListener />
                <VerticalSignPoleDetailsSidebar />,
            </VerticalSignPoleValidator>,
        },
        {
            path: "/:road/*",
            element: <NavigateWithParams replace to={`../:road?${searchParams}`} />,
        },
    ])

    return roadwayRoutes
}